import styled from 'styled-components'

const StyledAccordeon = styled.div`
  th{
    padding-bottom: 10px;
  }
  .accordion__button{
    background-color: #00549a;
    color: #fff;
    cursor: pointer;
    padding: 10px;
    width: 100%;
    text-align: left;
    border: none;
  }
`;

export default StyledAccordeon